import { render, staticRenderFns } from "./Tentang.vue?vue&type=template&id=51342ba4&"
import script from "./Tentang.vue?vue&type=script&lang=js&"
export * from "./Tentang.vue?vue&type=script&lang=js&"
import style0 from "./Tentang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports